import { Platform } from "react-native";
import styled, { css } from "styled-components/native";
import { radii, space, color } from "@sloth-system/styled-utils";
import {
  variant,
  BackgroundColorProps,
  PaddingProps,
} from "@sloth-system/props";
import { hexToRgbA } from "./Button-helpers";

export { Button };

type SlothProps = BackgroundColorProps & PaddingProps;
export interface ButtonStyleProps extends SlothProps {
  type?: "rounded" | "circle-like" | "full-circle";
  size?: "s" | "m" | "l";
  fs?: string;
  disabled?: boolean;
  radius?: string;
}

export function detectMainColor(prefferedColor = "primary") {
  return function (props) {
    let mainColor = props.disabled ? "neutrals.300" : `${prefferedColor}.main`;
    return color(mainColor);
  };
}

export function radius() {
  return function (props) {
    let borderRadius = props.radius ? props.radius : "xm";
    return radii(borderRadius);
  };
}

function findAndMakeTransparentColor(prefferedColor) {
  return function (props) {
    return hexToRgbA(color(prefferedColor)(props), "0.3");
  };
}

let fillVariant = variant("fill", {
  primary: css`
    background-color: ${detectMainColor("primary")};
    border-radius: ${radius()};
  `,
  secondary: css`
    background-color: ${detectMainColor("secondary")};
    border-radius: ${radius()};
  `,
  white: css`
    background-color: ${(props) => {
      return `${props.theme.color.common.white}`;
    }};
    border-radius: ${radius()};
  `,
  transparent: css``,
  transparentWhite: css`
    background-color: ${findAndMakeTransparentColor("common.white")};
    border-radius: ${radii("l")};
  `,
});
let outlineVariant = variant("outline", {
  primary: css`
    border-radius: ${radius()};
    border: 1px solid ${detectMainColor("primary")};
  `,
  secondary: css`
    border-radius: ${radius()};
    border: 1px solid ${detectMainColor("secondary")};
  `,
});

let sizeVariant = variant("size", {
  s: css`
    padding-top: ${space("s")};
    padding-bottom: ${space("s")};
    padding-left: ${space("m")};
    padding-right: ${space("m")};
  `,
  m: css`
    padding-top: ${space("m")};
    padding-bottom: ${space("m")};
    padding-left: ${space("l")};
    padding-right: ${space("l")};
  `,
  l: css`
    padding-top: ${space("l")};
    padding-bottom: ${space("l")};
    padding-left: ${space("xl")};
    padding-right: ${space("xl")};
  `,
});

let buttonWebStyles = "";
if (Platform.OS === "web") {
  buttonWebStyles = `display: block !important;`;
}

let Button = styled.TouchableOpacity<ButtonStyleProps>`
  ${buttonWebStyles}
  ${sizeVariant}
  ${fillVariant}
  ${outlineVariant}
`;
